import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_CLOCK_LOGS_REPORT } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import { notifySuccess, notifyError } from '@/lib/notifications'

const clockLogsReport = {
  namespaced: true,
  state: buildInitialState({
    clockWeekLogs: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setclockWeekLogs: (state, clockWeekLogs) => {
      state.clockWeekLogs = clockWeekLogs
    }
  },
  actions: {
    getclockWeekLogs: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting time, please wait...' })

      return api.doGet({ path: PATH_CLOCK_LOGS_REPORT, parameters: filters })
        .then(json => json.data)
        .then(clockWeekLogs => {
          commit('updateStatus', { status: COMPLETE })
          commit('setclockWeekLogs', clockWeekLogs)
          return clockWeekLogs
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get time. Try again later')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveClockApprovedLogs: ({ commit, dispatch }, payLoad) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving time to time management, please wait...' })
      return api.doPost({ path: PATH_CLOCK_LOGS_REPORT, data: payLoad })
        .then(json => json.data)
        .then(approvedLogsResponse => {
          commit('updateStatus', { status: COMPLETE })
          if (!approvedLogsResponse) {
            throw new Error('Unable to save time to time management. Try again later')
          }
          notifySuccess(dispatch, 'Time saved to time management')
          return approvedLogsResponse
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save time to time management. Try again later')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default clockLogsReport
